import axios from "axios";
import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Switch, Redirect, Route, useHistory, useLocation } from "react-router-dom";
import { _serverUrl2 } from "../../config";
import { clearUserInfo, setUserInfo } from "../../Redux/Slices/userSlice";
import { getCookie } from "../../Utils/Cookies";
import LoginPage from "../Pages/Login/LoginPage";
import Dashboard from "./Dashboard";

function App() {
  const { Auth } = useSelector((state) => state.getUserInfo);
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory()

  const checkToken = useCallback(async () => {
    try {
      const response = await axios.post(`${_serverUrl2}/user/checkToken`, { token: getCookie("token") });
      if (response.data.rows.length !== 0) {
        const user = response.data.rows[0];
        const { common } = axios.defaults.headers
        common["plaka"] = user.plaka_kod;
        common["Authorization"] = `Bearer ${user.token}`;
        common["id"] = user.id;
        dispatch(setUserInfo(user));
        history.push(location.pathname)
      }
    } catch (error) {
      console.error("Error checking token", error);
    } // eslint-disable-next-line
  }, []);

  useEffect(() => {
    let isMounted = true;
    let responseIntercept = null;

    if (isMounted && !!getCookie("token")) {
      checkToken();

      responseIntercept = axios.interceptors.response.use(
        (response) => response,
        async (error) => {
          if (error.response?.status === 401) {
            console.log("Token has expired, logging out", error);
            dispatch(clearUserInfo());
          }
          return Promise.reject(error);
        }
      );
    }

    return () => {
      if (isMounted && responseIntercept) {
        axios.interceptors.response.eject(responseIntercept);
      }
      isMounted = false;
    };
  }, [checkToken, dispatch]);

  return (
      <Switch>
        <Route exact path="/">
          {Auth ? <Redirect to="/dashboard" /> : <Redirect to="/login" />}
        </Route>
        <Route path="/login">
          {Auth ? <Redirect to="/dashboard" /> : <LoginPage />}
        </Route>
        <Route path="/dashboard">
          {Auth ? <Dashboard /> : <Redirect to="/login" />}
        </Route>
      </Switch>
  );
}

export default App;
